module.exports = __webpack_public_path__ + "static/media/home_section_bg_22.1327c719.jpg";